import React, {useContext, useEffect} from "react";
import { Icon } from "../StaleComponents";
import { FileButton, ActionIcon } from "@mantine/core";
import {AppContext} from "../../../../contexts/appContext";
import {useFiles} from "../../../../hooks/useFiles";

const AttachFileButton = ({ handleFileUpload }) => {
  const context = useContext(AppContext);
  const { filesContext } = context;

  const files = useFiles()

  return (
    <>
      <FileButton
        onChange={(f) => {
          filesContext.addFile(f)
          handleFileUpload()
        }}
        accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, .txt"
        disabled={files.length > 4}
      >
        {(props) => (
          <ActionIcon {...props} size={"xs"} style={{ marginTop: "4px" }}>
            <Icon>attach_file</Icon>
          </ActionIcon>
        )}
      </FileButton>
    </>
  );
};

export default AttachFileButton;